/**
 * @fileoverview GET handler for the "/app_settings/objects_using_products" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsObjectsUsingProducts } from "./constants";
import type { AppSettingsObjectsUsingProductsResult } from "./types";

export const getAppSettingsObjectsUsingProducts = reactQueryFetcherAdapter(
  appSettingsObjectsUsingProducts,
  (signal: AbortSignal, itemNames: string[]): Promise<AppSettingsObjectsUsingProductsResult> => {
    return fetch("/app_settings/objects_using_products", "GET", { item_names: itemNames }, { signal });
  }
);
